import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import useDataContext from "../providers/DataProvider/useDataContext";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import Whatsapp from "../components/Whatsapp/Whatsapp";
import RoomPagination from "../components/RoomPagination/RoomPagination";
import RoomFullCard from "../components/RoomFullCard/RoomFullCard";
import Spinner from "../components/Spinner/Spinner";
import InstagramButton from "../components/InstagramButton/InstagramButton";

interface LocationState {
    roomIndex: number
}

const RoomsPage: React.FC = () => {
    const { data } = useDataContext();
    const location = useLocation();
    // Con esto se verifica si el índice del departamento a mostrar es porque el
    // usuario clickió sobre una card en la página de inicio. En caso contrario,
    // se muestra el primero que esté definido en el archivo JSON.
    const locationState = location.state as LocationState | undefined;
    const [roomIndex, setRoomIndex] = useState<number>(locationState?.roomIndex ?? 0);
    const [roomInfo, setRoomInfo] = useState(() => {
        const foundRoom = data.rooms.find(room => room.index === roomIndex);
        return foundRoom ? foundRoom : data.rooms[0]
    });
    const roomNames = data.rooms.map(room => room.name);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth"});
        setIsLoading(true);
        setRoomInfo(() => {
            const foundRoom = data.rooms.find(room => room.index === roomIndex);
            return foundRoom ? foundRoom : data.rooms[0]
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [roomIndex])

    const allImagesLoaded = () => {
        setTimeout(() => setIsLoading(false), 1000);
    }

    return (
    <>
        <Header isHomePage={false}/>
        <main className="bg-forth-solid px-4">
            <RoomPagination roomIndex={roomIndex}
                            setRoomIndex={setRoomIndex}
                            roomNames={roomNames}/>

            { isLoading && <Spinner color="bg-first-solid" pxSize={20}/> }

            <RoomFullCard roomInfo={roomInfo}
                          bookTo={ data.pages.bookPage.externalUrl }
                          bookText={ data.pages.roomsPage.bookButtonText }
                          onAllImagesLoaded={allImagesLoaded}
                          isHidden={isLoading}/>

        </main>
        <InstagramButton isHomePage={false}/>
        <Whatsapp isHomePage={false}/>
        <Footer isHomePage={false}/>
    </>
    )
}

export default RoomsPage;
